import React from 'react';

import Account from './Account';
import AuthRoute from '../common/AuthRoute';

const accountRouter = () => (
    <AuthRoute key='account-route' exact path='/account' component={Account} />
);

export default accountRouter;